/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import './app/app.js';
import './app/app.controller.js';
import './app/home/home.controller.js';
import './app/handsontable/handsonHelper.js';
import './app/notebook/notebook.controller.js';

/** start: global variable `zeppelin` related files */
import './app/tabledata/tabledata.js';
import './app/tabledata/transformation.js';
import './app/tabledata/pivot.js';
import './app/tabledata/passthrough.js';
import './app/tabledata/columnselector.js';
import './app/visualization/visualization.js';
import './app/visualization/builtins/visualization-table.js';
import './app/visualization/builtins/visualization-nvd3chart.js';
import './app/visualization/builtins/visualization-barchart.js';
import './app/visualization/builtins/visualization-piechart.js';
import './app/visualization/builtins/visualization-areachart.js';
import './app/visualization/builtins/visualization-linechart.js';
import './app/visualization/builtins/visualization-scatterchart.js';
/** end: global variable `zeppelin` related files */

import './app/jobmanager/jobmanager.controller.js';
import './app/jobmanager/jobs/job.controller.js';
import './app/jobmanager/jobmanager.filter.js';
import './app/interpreter/interpreter.controller.js';
import './app/interpreter/interpreter.filter.js';
import './app/credential/credential.controller.js';
import './app/configuration/configuration.controller.js';
import './app/notebook/paragraph/paragraph.controller.js';
import './app/notebook/paragraph/result/result.controller.js';
import './app/search/result-list.controller.js';
import './app/notebookRepos/notebookRepos.controller.js';
import './app/helium/helium.controller.js';
import './components/arrayOrderingSrv/arrayOrdering.service.js';
import './components/clipboard/clipboard.controller.js';
import './components/navbar/navbar.controller.js';
import './components/ngescape/ngescape.directive.js';
import './components/interpreter/interpreter.directive.js';
import './components/expandCollapse/expandCollapse.directive.js';
import './components/noteName-create/notename.controller.js';
import './components/noteName-import/notenameImport.controller.js';
import './components/popover-html-unsafe/popover-html-unsafe.directive.js';
import './components/popover-html-unsafe/popover-html-unsafe-popup.directive.js';
import './components/editor/codeEditor.directive.js';
import './components/ngenter/ngenter.directive.js';
import './components/dropdowninput/dropdowninput.directive.js';
import './components/resizable/resizable.directive.js';
import './components/noteName-create/visible.directive.js';
import './components/websocketEvents/websocketMsg.service.js';
import './components/websocketEvents/websocketEvents.factory.js';
import './components/noteListDataFactory/noteList.datafactory.js';
import './components/baseUrl/baseUrl.service.js';
import './components/browser-detect/browserDetect.service.js';
import './components/saveAs/saveAs.service.js';
import './components/searchService/search.service.js';
import './components/login/login.controller.js';
import './components/elasticInputCtrl/elasticInput.controller.js';
import './components/noteAction/noteAction.service.js';
import './components/notevarshareService/notevarshare.service.js';
import './components/rename/rename.controller.js';
import './components/rename/rename.service.js';
import './components/helium/helium.service.js';



// WEBPACK FOOTER //
// ./src/index.js